import React from 'react';
import THEME from '../theme.js';
import Badge from './Badge.js';
const CaseGroup = (props) => {
    return (React.createElement(Badge, { style: {
            fontSize: '0.6em',
            ...props.style,
        }, theme: THEME.NEUTRAL }, props.caseGroup.label));
};
export default CaseGroup;
//# sourceMappingURL=CaseGroup.js.map